import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TertiaryButton } from 'DesignSystem/Buttons';

const ModalTertiaryButton = (props) => {
  const {
    btnCopy,
    className,
    onClick,
    leadingCopy,
    variation,
  } = props;

  if (!btnCopy) {
    return null;
  }

  const tertiaryClasses = classNames(
    'ds-modal-tertiary-btn',
    className,
  );

  const LeadingCopy = useCallback(
    () => (
      leadingCopy ? <span className="ds-modal-leading-tertiary-btn-copy">{leadingCopy}</span> : null
    ), [leadingCopy],
  );

  return (
    <div className="ds-modal-btn-row">
      <LeadingCopy />
      <div className="ds-modal-tertiary-btn-container">
        <TertiaryButton
          className={tertiaryClasses}
          onClick={onClick}
          variation={variation}
        >
          {btnCopy}
        </TertiaryButton>
      </div>
    </div>
  );
};

ModalTertiaryButton.defaultProps = {
  btnCopy: '',
  className: '',
  leadingCopy: '',
  onClick: () => {},
  variation: '',
};

ModalTertiaryButton.propTypes = {
  className: PropTypes.string,
  btnCopy: PropTypes.string,
  leadingCopy: PropTypes.string,
  onClick: PropTypes.func,
  variation: PropTypes.oneOf([
    '',
    'alternative',
  ]),
};

export default ModalTertiaryButton;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/FormSwiftModal/ModalTertiaryButton.jsx